import { LIGHT_BLUE_BACKGROUND } from "../../../../constants/colors"
import { Box, Flex, Text, Tooltip } from "@mantine/core"

const CustomersNamesBars = ({ customers } : { customers:any[] }) => {
  
  return (
    <Flex  maw={'99%'} gap={8} >
      {customers && customers.length > 0 && customers?.map(customer => (
        <Tooltip key={customer._id} label={customer?.name}>
          <Box 
            bg={LIGHT_BLUE_BACKGROUND} 
            px={8} 
            py={4} 
            style={{ 
              borderRadius: 4,
              maxWidth: '200px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            <Text>{customer?.name}</Text>
          </Box>
        </Tooltip>
      ))}
    </Flex>
  )
}

export default CustomersNamesBars